@if(accountingInformation){
    @if(accountingInformation.accountingInformation.length > 0){
       <div class="grid">
            <div class="col-12">
            <h3 class="m-0" translate>financial_information</h3>
        </div>
        <div class="col-12">
            @for (item of accountingInformation.accountingInformation; track $index) {
                <div class="card shadow-5 m-0 flex align-items-center mb-3">
                    <div class="grid m-0 w-full">
                        <div class="col-12 md:col-11">
                            <div class="grid">
                                <div class="col-12 p-0">
                                    <div class="grid m-0">
                                        <div class="col-12 md:col-4 flex align-items-center ">
                                            <p class="m-0"><i pTooltip="{{ 'accounting_information_period' | translate }}" style="font-size: 18px;" class="cursor-pointer fas fa-calendar-check mr-3"></i>{{item.accountingYearRegistry}}</p>
                                        </div>
                                        <div class="col-12 md:col-5 flex align-items-center">
                                            <p class="m-0"><i pTooltip="{{ 'inventories_stocks' | translate }}" style="font-size: 18px;" class="cursor-pointer fas fa-boxes mr-3"></i>USD {{item.accountingStockInventoryUSD | number:'1.2-2'}}</p>
                                        </div>
                                        <div class="col-12 md:col-3">
                                            <p class="m-0 flex align-items-center"><i pTooltip="{{ 'balance_sheet' | translate }}"
                                                    style="font-size: 18px;"
                                                    class="cursor-pointer fas fa-file-invoice-dollar mr-3"></i> <button
                                                    (click)="opFilesAb.toggle($event)"
                                                    [disabled]="item.accountingBalanceSheet.length === 0" pButton pRipple
                                                    type="button"
                                                    label="{{item.accountingBalanceSheet.length}} - {{ 'BALANCE' | translate}}"
                                                    class="p-button-rounded p-button-secondary w-button p-button-outlined "></button>
                                            </p>
                                            <p-overlayPanel #opFilesAb>
                                                <ng-template pTemplate>
                                                    <app-list-files [files]="item.accountingBalanceSheet"
                                                        (update)="item.accountingBalanceSheet = $event"></app-list-files>
                                                </ng-template>
                                            </p-overlayPanel>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12 p-0">
                                    <div class="grid m-0">
                                        <div class="col-12 md:col-4 flex align-items-center ">
                                            <p class="m-0"><i pTooltip="{{ 'share_capital' | translate }}" style="font-size: 18px;"
                                                    class="cursor-pointer fas fa-university mr-3"></i>USD
                                                {{item.accountingCapitalStockUSD | number:'1.2-2'}} </p>
                                        </div>
                                        <div class="col-12 md:col-5 flex align-items-center">
                                            <p class="m-0"><i style="font-size: 18px;"
                                                    pTooltip="{{ 'machinery_equipment' | translate }}"
                                                    class="cursor-pointer fas fa-cog mr-3"></i>USD {{item.accountingAssetsUSD |
                                                number:'1.2-2'}} </p>
                                        </div>
                                        <div class="col-12 md:col-3 flex align-items-center">
                                            <p class="m-0 flex align-items-center"><i
                                                    pTooltip="{{ 'profit_statement' | translate }}" style="font-size: 18px;"
                                                    class="cursor-pointer fas fa-file-invoice-dollar mr-3"></i> <button
                                                    (click)="opFilesAc.toggle($event)"
                                                    [disabled]="item.accountingProfitLossStatement.length === 0" pButton pRipple
                                                    type="button"
                                                    label="{{item.accountingProfitLossStatement.length}} - {{ 'STATE' | translate}}"
                                                    class="p-button-rounded p-button-secondary w-button p-button-outlined "></button>
                                            </p>
                                            <p-overlayPanel #opFilesAc>
                                                <ng-template pTemplate>
                                                    <app-list-files [files]="item.accountingProfitLossStatement"
                                                        (update)="item.accountingProfitLossStatement = $event"></app-list-files>
                                                </ng-template>
                                            </p-overlayPanel>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            }
        </div>
        <div class="col-12">
            <div class="card shadow-5 m-0">
                <div class="grid">
                    <div class="col-12">
                        <h3 class="m-0" translate>annual_sales</h3>
                    </div>
                    <div class="col-12" style="overflow-x: auto;">
                        <div class="grid m-0" style="min-width: 550px;">
                            <div class="col-7 total-top flex align-items-center justify-content-center">
                                <div class="detail-total">
                                    <div class="row-range">
                                        <span class="title-row" translate>sales_range</span>
                                        <span *ngIf="formAmount > 0" class="range-title">{{rangeSales}}</span>
                                        <span *ngIf="formAmount <= 0" class="range-title" translate>NO_SALES_RECORD</span>
                                    </div>
                                    <div class="row-range">
                                        <span class="title-row" translate>average_income</span>
                                        <span *ngIf="formAmount > 0" class="promedio-title">USD {{formAmount |
                                            number:'1.2-2'}}</span>
                                        <span *ngIf="formAmount <= 0" class="promedio-title">USD -</span>
                                    </div>
                                </div>
                            </div>
                            <div class="col-5">
                                <div class="grid">
                                    <div class="col-12 p-0">
                                        <div class="grid m-0">
                                            <div class="col-5"><span class="title-row2">{{yearNow}}</span>
                                            </div>
                                            <div class="col-7"><span class="title-row2" translate>sales</span></div>
                                        </div>
                                    </div>
                                    <div class="col-12 p-0">
                                        <div class="grid">
                                            <div class="col-5">
                                                <div class="center-text-flex">
                                                    {{annualSaleYear1}}</div>
                                            </div>
                                            <div class="col-7">
                                                <div class="center-text-flex">USD
                                                    {{annualSaleAmount1USD |
                                                    number:'1.2-2'}}</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-12 p-0">
                                        <div class="grid">
                                            <div class="col-5">
                                                <div class="center-text-flex">
                                                    {{annualSaleYear2}}</div>
                                            </div>
                                            <div class="col-7">
                                                <div class="center-text-flex">USD
                                                    {{annualSaleAmount2USD |
                                                    number:'1.2-2'}}</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-12 p-0">
                                        <div class="grid">
                                            <div class="col-5">
                                                <div class="center-text-flex">
                                                    {{annualSaleYear3}}</div>
                                            </div>
                                            <div class="col-7">
                                                <div class="center-text-flex">USD
                                                    {{annualSaleAmount3USD |
                                                    number:'1.2-2'}}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
       </div>
        
    }
}
